module.exports = __webpack_public_path__ + "3cca891e1cf184959ca805fb1c38ff23.png";